define('tdstepmats', ['jquery'], function ($) {

    return {
        document: $(document),
        template: $('#stepmatsTpl').html(),
        stepContainer: $('#stepmatform'),
        cloneFormButton: $('#clonestepmatform'),
        sendFormButton: $('#sendstepmatform'),
        stepmatformular: $('#stepmatformular'),
        stepFormat: $('[data-format]'),
        hiddenForm: $('#hidden-form'),
        send: false,
        index: 1,
        init: function init() {
            this.setForm();
            this.cloneForm();
            this.bindEvents();
        },
        setForm: function setForm() {
            this.hiddenForm.insertAfter(this.cloneFormButton);
        },
        cloneForm: function cloneForm() {
            var _this = this;

            if (!this.template) return;
            var html = this.template.replace(/__NUM__/gm, this.index++);
            this.stepContainer.append(html);
            var currentProductName = $('#productname_' + (this.index - 2)).val();
            var currentFormatIndex = $('#formatSelect_' + (this.index - 2) + ' option:selected').val();
            if (currentFormatIndex !== 'undefined') this.setFormat(currentFormatIndex);
            if (currentProductName !== 'undefined' && this.index > 2) setTimeout(function () {
                return $('#productname_' + (_this.index - 1)).val(currentProductName);
            }, 100);
        },
        sendForm: function sendForm(e) {
            e.preventDefault();
            var json = this.stepmatformular.serializeArray();
            var value = "";
            $.each(json, function (i, obj) {
                if (obj.value !== "") value += obj.name + ' = ' + obj.value + "\n";
            });
            this.hiddenForm.find('textarea').val(value);
            this.hiddenForm.find('[type="submit"]').click();
        },
        changeForm: function changeForm(select) {
            var value = select.val();
            var row = select.closest('.stepmats__row');
            var additionalfield = row.find('.stepmats__additional');
            var canvasContainer = row.find('.stepmats__canvas');
            this.additionalfields(value === "2", additionalfield);
            var form = value;
            var curve = row.find('[type="checkbox"]').is(':checked');
            var lauf = row.find('[type="radio"]:checked').val();

            canvasContainer.find('img').hide();
            canvasContainer.find('.stepmats__curve [data-form="' + value + '"][data-curve="' + curve + '"]').show();

            if (form === "0") {
                canvasContainer.find('.stepmats__polygon [data-form="' + value + '"]').show();
            }
            row.find('.radio, .winkel').css({ opacity: '1', pointerEvents: 'auto' });
            canvasContainer.find('.stepmats__polygon [data-form="' + value + '"][data-lauf="' + lauf + '"]').show();
        },
        additionalfields: function additionalfields(value, field) {
            if (value) {
                field.show().find('input').attr('required', true);
            } else {
                field.hide().find('input').attr('required', false);
            }
        },
        setFormat: function setFormat(value) {
            $('#formatSelect_' + (this.index - 1)).val(value).trigger('change');
        },
        bindEvents: function bindEvents() {
            var _this2 = this;

            this.cloneFormButton.on('click', function () {
                return _this2.cloneForm();
            });
            this.stepFormat.on('click', function (e) {
                return _this2.setFormat($(e.currentTarget).data('format'));
            });
            this.document.on('change', '[id^=formatSelect]', function (e) {
                return _this2.changeForm($(e.currentTarget));
            });
            this.stepmatformular.submit(function (e) {
                return _this2.sendForm(e);
            });

            this.stepContainer.find('[type=number]').on('keyup', function (e) {
                var self = $(e.currentTarget);
                var value = self.val().split(/[,|.]/g)[0];
                self.val(value);
            });

            this.document.on('click', '.fa-trash', function (e) {
                var self = $(e.currentTarget);
                self.closest('.stepmats__row').remove();
                _this2.index = _this2.index - 1;
            });

            this.document.on('click', '.stepmats__form [type="checkbox"]', function (e) {
                var self = $(e.currentTarget);
                var select = $('[name="' + self.attr('name').replace('abkantung', 'format') + '"]');
                if (!!select.val()) select.trigger('change');
            });

            this.document.on('click', '.stepmats__form [type="radio"]', function (e) {
                var self = $(e.currentTarget);
                var select = $('[name="' + self.attr('name').replace('lauf', 'format') + '"]');
                if (!!select.val()) select.trigger('change');
            });
        }
    };
});

